import { render } from "./Plans.vue?vue&type=template&id=c21f57ac&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=c21f57ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21f57ac"]])

export default __exports__